import {
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output
}                             from '@angular/core';
import { TranslationService } from '@core/services/translation.service';
import { ValueTypeEnum }      from '@models/common.model';
import {
	GroupStateEnum,
	IGroupConfig
}                             from '@shared/components/group/group.model';
import {
	ContentUtils,
	ObjectUtils
}                             from '@utils/helpers';

@Component( {
	selector: 'app-group',
	templateUrl: './group.component.html',
	styleUrls: [ './group.component.scss' ]
} )

export class GroupComponent {

	private _groupConfig: IGroupConfig;
	isCollapsed: boolean;
	isHovered: boolean;

	@Output() isCollapsedEvent = new EventEmitter<boolean>();

	@Input() set groupConfig( groupConfig: IGroupConfig ) {
		this._groupConfig = this.sanitizeGroupDataConfig( groupConfig );
	}

	get groupConfig(): IGroupConfig {
		return this._groupConfig;
	}


	@Input() set baseClass( baseClass: string ) {
		this.hostClass = this.hostClass = baseClass ? baseClass : null;
	}

	@HostBinding( 'class' ) hostClass: string;
	@HostBinding( 'class.mb-4' ) contentsAreVisible: boolean;

	constructor(
		private readonly translationService: TranslationService
	) {}


	private sanitizeGroupDataConfig( groupConfig: IGroupConfig ): IGroupConfig {
		groupConfig = ObjectUtils.deepCopy( groupConfig ?? this._groupConfig );

		groupConfig = {
			...groupConfig,
			collapsable: groupConfig?.collapsable ?? true,
			defaultState: groupConfig?.defaultState ?? GroupStateEnum.EXPANDED,
			disabled: groupConfig?.disabled ?? false,
			labelValue: groupConfig?.labelValue ?? null,
			labelValueType: groupConfig?.labelValueType ?? ValueTypeEnum.VALUE,
			labelSpareValue: groupConfig?.labelSpareValue ?? '-',
			renderHeader: groupConfig?.renderHeader ?? true,
			showLabel: groupConfig?.showLabel ?? true,
			showToggleIcon: groupConfig?.showToggleIcon ?? true,
			showFooterSeparator: groupConfig?.showFooterSeparator ?? false,
			showHeaderSeparator: groupConfig?.showHeaderSeparator ?? false
		};

		if ( this.isCollapsed === undefined ) {
			this.isCollapsedEvent.emit( this.isCollapsed );
		}

		this.isCollapsed = groupConfig.defaultState === GroupStateEnum.COLLAPSED
											 ? true
											 : groupConfig.collapsable === false
												 ? false
												 : !!this.isCollapsed;

		this.setContentsAreVisible();

		if ( this.contentsAreVisible === this.isCollapsed ) {
			this.isCollapsedEvent.emit( this.isCollapsed );
		}

		return groupConfig;
	}

	getValueByGroupValueType(): any {
		return ContentUtils.getValueByValueType(
			this.groupConfig.labelValueType,
			this.groupConfig.labelValue,
			this.groupConfig.labelSpareValue,
			this.translationService
		);
	}

	toggleCollapsedState(): void {
		this.isCollapsed = !this.isCollapsed;
		this.setContentsAreVisible();
		this.isCollapsedEvent.emit( this.isCollapsed );
	}

	setContentsAreVisible(): void {
		this.contentsAreVisible = !this.isCollapsed;
	}
}
